import React from "react";
import { cn } from "../lib/cn";

export default function Reveal({ children, className = "", delay = 0 }) {
  return (
    <div
      data-fk-reveal
      className={cn("fk-reveal", className)}
      style={{ "--fk-reveal-delay": `${delay}s` }}
    >
      {children}
    </div>
  );
}

